var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoMessages(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 245,
    height: 131,
    viewBox: "0 0 245 131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M62 50h142v79H62z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#CECECE",
    strokeWidth: 2,
    d: "M81 48V6a5 5 0 0 1 5-5h96a5 5 0 0 1 5 5v42M94 16.889h78M94 31h56M200 49H67a4 4 0 0 0-4 4v73a4 4 0 0 0 4 4h133a4 4 0 0 0 4-4V53a4 4 0 0 0-4-4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C5C5C5",
    strokeWidth: 2,
    d: "M50 87H.5M42 97H26"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#CECECE",
    strokeWidth: 2,
    d: "M72 59l62.5 35L197 59M113 94l-43 29M154 94l43 29-43-29z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#C5C5C5",
    strokeLinecap: "square",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43 13.44v21.193M32 24h22"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C5C5C5",
    fillRule: "nonzero",
    d: "M243.483 65.202h-.413v-3.648c0-4.715-3.842-8.554-8.573-8.554-4.725 0-8.573 3.833-8.573 8.554a.78.78 0 0 0 .785.783.78.78 0 0 0 .784-.783c0-3.85 3.139-6.988 7.004-6.988 3.86 0 7.004 3.132 7.004 6.988v3.648h-15.984c-.837 0-1.517.679-1.517 1.514v9.749c0 2.5 2.04 4.535 4.545 4.535h11.91c2.505 0 4.545-2.036 4.545-4.535v-9.75c0-.834-.68-1.513-1.517-1.513zm-.052 11.263a2.975 2.975 0 0 1-2.976 2.97H228.55a2.975 2.975 0 0 1-2.976-2.97v-9.697h17.856v9.697z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMessages);
export default __webpack_public_path__ + "static/media/noMessages.d440cba1f19439ad0297129dabf4d6a4.svg";
export { ForwardRef as ReactComponent };